interface AddToCalendarSvgProps {
  isLoading: boolean;
}

const AddToCalendarSvg = ({ isLoading }: AddToCalendarSvgProps) => {
  const loadingCssClassName = isLoading ? "loading" : "";
  return (
    <svg
      width="183"
      height="137"
      viewBox="0 0 183 137"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="block m-auto mb-2"
    >
      <path
        id="1"
        d="M85.1673 108.96C111.074 108.96 132.076 87.8866 132.076 61.8913C132.076 35.8959 111.074 14.8225 85.1673 14.8225C59.2602 14.8225 38.2583 35.8959 38.2583 61.8913C38.2583 87.8866 59.2602 108.96 85.1673 108.96Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        id="1"
        d="M129.834 25.7826C131.296 24.4418 131.398 22.1655 130.062 20.6982C128.726 19.231 126.457 19.1285 124.995 20.4693C123.533 21.8102 123.43 24.0865 124.767 25.5537C126.103 27.021 128.372 27.1234 129.834 25.7826Z"
        fill="#EAEEF9"
      />
      <path
        id="1"
        d="M58.0578 18.862C59.2971 18.4578 59.9752 17.1221 59.5724 15.8786C59.1696 14.635 57.8384 13.9546 56.5991 14.3588C55.3597 14.763 54.6816 16.0987 55.0844 17.3422C55.4873 18.5858 56.8185 19.2662 58.0578 18.862Z"
        fill="#EAEEF9"
      />
      <path
        id="1"
        d="M111.406 100.626H26.1772L41.7506 28.7444H127.074L111.406 100.626Z"
        fill="white"
      />
      <path
        id="1"
        d="M111.406 100.626H26.1772L41.7506 28.7444H127.074L111.406 100.626Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        id="1"
        opacity="0.1"
        d="M62.2321 100.626H44.5822C41.3731 100.626 38.7304 97.8796 38.9192 94.6596L41.7507 28.7444H45.998L62.2321 100.626Z"
        fill="#9CA4B5"
      />
      <path
        id="1"
        d="M145.762 100.626H60.5331L46.0924 45.4126L45.998 45.0337L41.7507 28.7444H127.074L130.755 42.8555L131.321 45.0337L131.416 45.4126L145.762 100.626Z"
        fill="white"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        id="1"
        d="M131.321 45.0335H47.158L42.9685 28.7441H127.132L130.763 42.8553L131.321 45.0335Z"
        fill="#F1F3F9"
      />
      <path
        id="1"
        d="M64.2141 40.393C65.8822 40.393 67.2344 39.0361 67.2344 37.3624C67.2344 35.6886 65.8822 34.3318 64.2141 34.3318C62.5461 34.3318 61.1938 35.6886 61.1938 37.3624C61.1938 39.0361 62.5461 40.393 64.2141 40.393Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        id="1"
        d="M114.049 40.393C115.717 40.393 117.069 39.0361 117.069 37.3624C117.069 35.6886 115.717 34.3318 114.049 34.3318C112.381 34.3318 111.029 35.6886 111.029 37.3624C111.029 39.0361 112.381 40.393 114.049 40.393Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        id="1"
        d="M63.4592 38.5937C62.8929 38.5937 62.4209 38.1202 62.4209 37.5519C62.4209 36.9837 62.8929 36.5102 63.4592 36.5102C65.5356 36.5102 67.7064 33.5743 67.7064 29.1231C67.7064 29.0284 67.7064 28.839 67.7064 28.7443C67.6121 24.3879 65.4412 21.7361 63.4592 21.7361C61.5715 21.7361 59.495 24.2931 59.2119 28.2708H57.041C57.3242 23.3461 60.0613 19.6526 63.3648 19.6526C66.857 19.6526 69.5941 23.7249 69.7829 28.9337C69.7829 29.0284 69.7829 29.1231 69.7829 29.2178C69.8773 34.4267 67.0458 38.5937 63.4592 38.5937Z"
        fill="#AAB2C5"
      />
      <path
        id="1"
        d="M113.011 38.5937C112.444 38.5937 111.972 38.1202 111.972 37.5519C111.972 36.9837 112.444 36.5102 113.011 36.5102C115.087 36.5102 117.258 33.5743 117.258 29.1231C117.258 29.0284 117.258 28.839 117.258 28.7443C117.164 24.3879 114.993 21.7361 113.011 21.7361C111.123 21.7361 109.047 24.2931 108.763 28.2708H106.593C106.876 23.3461 109.613 19.6526 112.916 19.6526C116.409 19.6526 119.146 23.7249 119.334 28.9337C119.334 29.0284 119.334 29.1231 119.334 29.2178C119.429 34.4267 116.597 38.5937 113.011 38.5937Z"
        fill="#AAB2C5"
      />
      <path
        id="1"
        d="M15.323 100.531H152.652"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="1"
        opacity="0.3"
        d="M114.521 66.3424C113.954 66.3424 113.577 65.8688 113.577 65.3953C113.577 64.8271 113.954 64.4482 114.521 64.4482H117.447C118.013 64.4482 118.391 64.9218 118.391 65.3953C118.391 65.9635 117.919 66.3424 117.447 66.3424H114.521Z"
        fill="#D5DAE8"
      />
      <path
        id="1"
        opacity="0.3"
        d="M74.3132 93.0495C73.9356 93.0495 73.5581 92.7654 73.3693 92.3866L71.8592 86.7989H64.4028C63.8365 86.7989 63.459 86.3254 63.459 85.8519C63.459 85.2836 63.9309 84.9048 64.4028 84.9048H71.2929L68.9333 76.5707H61.7601C61.1938 76.5707 60.8162 76.0972 60.8162 75.6236C60.8162 75.0554 61.1938 74.6766 61.7601 74.6766H68.367L66.0074 66.3425H59.2117C58.6454 66.3425 58.2679 65.869 58.2679 65.3954C58.2679 64.8272 58.6454 64.4484 59.2117 64.4484H65.5355L63.1758 56.1143H56.6633C56.097 56.1143 55.7195 55.6407 55.7195 55.1672C55.7195 54.599 56.097 54.2201 56.6633 54.2201H62.6095L61.6657 50.8107C61.5713 50.3372 61.8545 49.769 62.3264 49.6743C62.4208 49.6743 62.5152 49.6743 62.6095 49.6743C62.9871 49.6743 63.3646 49.9584 63.5534 50.3372L64.686 54.2201H72.2367C72.803 54.2201 73.1806 54.599 73.1806 55.1672C73.1806 55.7354 72.803 56.1143 72.2367 56.1143H65.2523L67.6119 64.4484H79.5043L75.7289 50.8107C75.6346 50.3372 75.9177 49.769 76.3896 49.6743C76.484 49.6743 76.5784 49.6743 76.6728 49.6743C77.0503 49.6743 77.4279 49.9584 77.6166 50.3372L78.7492 54.2201H82.8078C83.3741 54.2201 83.7516 54.599 83.7516 55.1672C83.7516 55.7354 83.2797 56.1143 82.8078 56.1143H79.3155L81.6751 64.4484H89.6978C90.2641 64.4484 90.6416 64.9219 90.6416 65.3954C90.6416 65.9637 90.2641 66.3425 89.6978 66.3425H82.2415L84.6011 74.6766H96.5878L91.3967 56.1143H88.8483C88.282 56.1143 87.9045 55.6407 87.9045 55.1672C87.9045 54.599 88.3764 54.2201 88.8483 54.2201H90.8304L89.8866 50.8107C89.7922 50.5266 89.8866 50.3372 89.981 50.0531C90.0753 49.8637 90.2641 49.6743 90.5473 49.5796C90.6416 49.5796 90.736 49.5796 90.8304 49.5796C91.2079 49.5796 91.5855 49.8637 91.7743 50.2425L92.9069 54.1254H94.8889C95.4552 54.1254 95.8328 54.5043 95.8328 55.0725C95.8328 55.6407 95.4552 56.0196 94.8889 56.0196H93.4732L95.8328 64.3537H107.82L105.46 56.0196H99.325C98.7587 56.0196 98.3811 55.546 98.3811 55.0725C98.3811 54.5043 98.8531 54.1254 99.325 54.1254H104.61L103.667 50.716C103.572 50.2425 103.855 49.6743 104.327 49.5796C104.422 49.5796 104.516 49.5796 104.61 49.5796C104.988 49.5796 105.366 49.8637 105.554 50.2425L106.687 54.1254H118.674L117.73 50.716C117.636 50.2425 117.919 49.6743 118.391 49.5796C118.485 49.5796 118.579 49.5796 118.674 49.5796C119.051 49.5796 119.429 49.8637 119.618 50.2425L120.75 54.1254H128.112C128.678 54.1254 129.056 54.5043 129.056 55.0725C129.056 55.6407 128.678 56.0196 128.112 56.0196H121.033L123.393 64.3537H130.472C131.038 64.3537 131.416 64.8272 131.416 65.3007C131.416 65.869 131.038 66.2478 130.472 66.2478H123.959L126.319 74.5819H133.115C133.681 74.5819 134.058 75.0554 134.058 75.5289C134.058 76.0972 133.681 76.476 133.115 76.476H126.885L129.245 84.8101H135.663C136.229 84.8101 136.607 85.2836 136.607 85.7572C136.607 86.3254 136.135 86.7042 135.663 86.7042H129.717L131.132 91.7236C131.227 92.1971 130.944 92.7654 130.472 92.8601C130.377 92.8601 130.283 92.8601 130.189 92.8601C129.811 92.8601 129.434 92.576 129.245 92.1971L127.735 86.7042H115.748L117.164 91.6289C117.258 91.913 117.164 92.1024 117.069 92.3866C116.975 92.576 116.786 92.7654 116.503 92.8601C116.409 92.8601 116.314 92.8601 116.22 92.8601C115.842 92.8601 115.465 92.576 115.276 92.1971L113.766 86.7989H101.779L103.195 91.7236C103.289 92.1971 103.006 92.7654 102.534 92.8601C102.44 92.8601 102.345 92.8601 102.251 92.8601C101.873 92.8601 101.496 92.576 101.307 92.1971L99.7969 86.7989H87.8101L89.2259 91.7236C89.3203 92.1971 89.0371 92.7654 88.5652 92.8601C88.4708 92.8601 88.3764 92.8601 88.282 92.8601C87.9045 92.8601 87.527 92.576 87.3382 92.1971L85.828 86.7989H73.8413L75.257 91.8183C75.3514 92.1024 75.257 92.2919 75.1626 92.576C75.0683 92.7654 74.8795 92.9548 74.5963 93.0495C74.5019 93.0495 74.4076 93.0495 74.3132 93.0495ZM101.213 84.9048H127.168L124.809 76.5707H112.822L113.671 79.6013C113.766 79.8854 113.671 80.0748 113.577 80.3589C113.483 80.5483 113.294 80.7378 113.011 80.8325C112.916 80.8325 112.822 80.8325 112.727 80.8325C112.35 80.8325 111.972 80.5483 111.784 80.1695L110.84 76.6654H107.253C106.687 76.6654 106.309 76.1919 106.309 75.7184C106.309 75.1501 106.687 74.7713 107.253 74.7713H110.274L107.914 66.4372H96.0215L98.3811 74.7713H101.307C101.873 74.7713 102.251 75.2448 102.251 75.7184C102.251 76.2866 101.873 76.6654 101.307 76.6654H98.8531L101.213 84.9048ZM87.2438 84.9048H99.2306L96.871 76.5707H84.8842L87.2438 84.9048ZM73.275 84.9048H85.2617L82.9021 76.5707H79.4099C78.8436 76.5707 78.4661 76.0972 78.4661 75.6236C78.4661 75.0554 78.938 74.6766 79.4099 74.6766H82.4302L80.0706 66.3425H68.0838L70.4434 74.6766H73.5581C74.1244 74.6766 74.5019 75.1501 74.5019 75.6236C74.5019 76.1919 74.03 76.5707 73.5581 76.5707H71.0097L73.275 84.9048ZM112.35 74.6766H124.337L119.146 56.1143H107.064L112.35 74.6766Z"
        fill="#D5DAE8"
      />
      <path
        id="1"
        d="M97.5699 82.0967C93.6478 82.0967 90.3533 79.5874 89.0983 75.9802C88.7845 75.1961 89.2552 74.4119 90.0396 74.0982C90.824 73.7846 91.6084 74.2551 91.9221 75.0392C92.7066 77.3917 95.0598 79.1169 97.5699 79.1169C100.08 79.1169 102.433 77.5486 103.217 75.0392C103.531 74.2551 104.315 73.7846 105.1 74.0982C105.884 74.4119 106.355 75.1961 106.041 75.9802C104.786 79.7442 101.492 82.0967 97.5699 82.0967Z"
        fill="#AAB2C5"
      />
      <path
        id="1"
        d="M105.608 64.2143C107.601 64.2143 109.216 62.5993 109.216 60.6071C109.216 58.6149 107.601 57 105.608 57C103.615 57 102 58.6149 102 60.6071C102 62.5993 103.615 64.2143 105.608 64.2143Z"
        fill="#AAB2C5"
      />
      <path
        id="1"
        d="M84.6083 64.2143C86.6011 64.2143 88.2165 62.5993 88.2165 60.6071C88.2165 58.6149 86.6011 57 84.6083 57C82.6155 57 81 58.6149 81 60.6071C81 62.5993 82.6155 64.2143 84.6083 64.2143Z"
        fill="#AAB2C5"
      />
      <g id="group" className={loadingCssClassName}>
        <path
          id="addCircle"
          d="M161.561 99.4866C161.121 101.391 160.461 103.408 159.692 105.088C157.603 109.233 154.305 112.482 150.238 114.61C146.059 116.739 141.113 117.635 136.165 116.515C124.512 114.05 117.036 102.399 119.454 90.5243C121.873 78.6493 133.197 70.9193 144.851 73.4959C149.028 74.3921 152.656 76.5207 155.734 79.4335C160.901 84.8108 162.99 92.3167 161.561 99.4866Z"
          fill="#D6DCE8"
          stroke="#AAB2C5"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </g>
      <path
        id="plus"
        d="M147.315 92.8242H143.169V88.6759C143.169 87.2722 142.07 86 140.495 86C139.092 86 137.821 87.1001 137.821 88.6759V92.8242H133.674C132.272 92.8242 131 93.9243 131 95.5001C131 96.2432 131.263 96.9223 131.758 97.4176C132.253 97.9126 132.932 98.1757 133.674 98.1757H137.821V102.324C137.821 103.728 138.92 105 140.495 105C141.898 105 143.169 103.9 143.169 102.324V98.1757H147.315C148.706 98.1757 149.968 97.0945 149.99 95.5402C150.132 93.8806 148.764 92.8242 147.315 92.8242Z"
        fill="white"
        stroke="#AAB2C5"
        stroke-width="2"
      />
    </svg>
  );
};
export default AddToCalendarSvg;
